module.exports = __webpack_public_path__ + "assets/f282a45ea754fdf16f9f3b7eafbfc2cd.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/jlondon/Desktop/Work-Resize/roc2/engine/public-src/spingames/panel/sounds/buttons/coins/bet_2.mp3
 ** module id = 39
 ** module chunks = 0
 **/